let infiniteScrollComponent = () => {
  return {
    restrict: 'E',
    scope: {
      getNextSetOfRowsToFetch: '&'
    },
    link: ($scope) => {
      let element = angular.element(document.querySelector('infinite-scroll'));
      let previousScrollHeight;

      element.on('scroll', () => {
        let hasScrollHeightChanged =  element[0].scrollHeight !== previousScrollHeight;
        let isEndOfScrollReached = (element[0].scrollTop + element[0].offsetHeight) >= element[0].scrollHeight;

        if (hasScrollHeightChanged && isEndOfScrollReached) {
          previousScrollHeight = element[0].scrollHeight;
          $scope.getNextSetOfRowsToFetch();
        }
      });
    }
  };
};
export
default infiniteScrollComponent;



// WEBPACK FOOTER //
// ./app/common/infiniteScroll/infiniteScroll.component.js